/* eslint-disable */
const TOKEN_KEY = "indopart-cpanel.key.token";

export const saveToken = (token) => {
  window.localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
};

export const destroyToken = () => {
  window.localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => {
  try {
    let tokenObject = localStorage.getItem(TOKEN_KEY);
    if (tokenObject) tokenObject = JSON.parse(tokenObject);
    return tokenObject;
  } catch (error) {
    destroyToken();
    return null;
  }
};

export default {
  getToken,
  saveToken,
  destroyToken,
};
